import moment from "moment";
import { TFunction } from "i18next";

import diskon from "../../../assets/images/icon_invoice/discount.svg";
import { isDarkColor } from "../../../config/DarkColorChecker";
import { formatCurrency } from "../../../config/global";
import { InvoiceDataItem } from "./InvoiceWebTypes";
import { InvoiceWebPagination } from "./InvoiceWebPagination";

type InvoiceWebHistorySectionProps = {
  data: InvoiceDataItem[];
  page: any;
  size: any;
  total: any;
  title: string;
  accentColor?: string;
  language: string;
  t: TFunction;
  onOpenSort: () => void;
  onChangePage: (page: any) => void;
  onChangeSize: (size: any) => void;
  onSelectItem: (item: InvoiceDataItem) => void;
  getIconInvoice: (item: InvoiceDataItem) => string | undefined;
};

export const InvoiceWebHistorySection = ({
  data,
  page,
  size,
  total,
  title,
  accentColor,
  language,
  t,
  onOpenSort,
  onChangePage,
  onChangeSize,
  onSelectItem,
  getIconInvoice,
}: InvoiceWebHistorySectionProps) => {
  return (
    <div>
      <div className="container">
        <div className="container rounded-xl px-3 ">
          <div className="grid grid-cols-1 gap-3">
            {data.map((item, index) => {
              const hasDiscount = item.detail?.some((detail) => {
                return detail.discount !== 0;
              });
              const paymentDate = item.invoiceDate
                ? moment(item.invoiceDate).locale(language).format("LL")
                : "-";
              const accountName = item.callerName || "-";
              const accountId = item.callerId || "-";
              const totalInvoice = formatCurrency(item.amount || 0);
              const paidAmount = formatCurrency(item.paidAmount || 0);
              const dueDate = item.dueDate
                ? moment(item.dueDate).locale(language).format("LL")
                : "-";
              const restInvoice = formatCurrency(
                (item.amount || 0) - (item.paidAmount || 0),
              );

              return (
                <div
                  key={
                    item.transactionId ||
                    `${item.invoiceId || item.title || "history"}-${index}`
                  }
                  className="text-dark text-lg mt-2 mb-4 container relative border rounded-xl"
                >
                  <div className="border-b-2 border-b-slate-700">
                    <div className="inline-flex">
                      <img
                        className="mr-4 mt-3 ml-2"
                        alt=""
                        src={getIconInvoice(item)}
                      />
                      <div className="mt-3 font-semibold text-[1.3vw]">
                        {item.title}
                      </div>
                    </div>
                    {hasDiscount ? (
                      <span className="mt-4 absolute right-0">
                        <img src={diskon} alt="diskon" />
                      </span>
                    ) : null}
                  </div>

                  <div className="flex flex-row relative justify-between">
                    <div className="flex flex-col relative w-4/12 mt-4 pb-4 text-slate-500">
                      <div className="flex flex-row relative">
                        <p className="text-[1vw]">{t("INVOICE.name")}</p>
                      </div>
                      <div className="flex flex-row relative">
                        <p className="text-[1vw]">{t("INVOICE.nis")}</p>
                      </div>
                      <div className="flex flex-row relative">
                        <p className="text-[1vw]">{t("INVOICE.date")}</p>
                      </div>
                    </div>
                    <div className="flex flex-col relative w-5/12 mt-4 pb-4 font-semibold">
                      <div className="flex flex-row relative">
                        <p className="text-[1vw]">
                          {" : "} {accountName}
                        </p>
                      </div>
                      <div className="flex flex-row relative">
                        <p className="text-[1vw]">
                          {" : "} {accountId}
                        </p>
                      </div>
                      <div className="flex flex-row relative">
                        <p className="text-[1vw]">
                          {" : "} {paymentDate}
                        </p>
                      </div>
                    </div>
                    <div className="flex flex-col relative w-4/12 mt-4 pb-4 text-slate-500">
                      <div className="flex flex-row relative">
                        <p className="text-[1vw]">{t("INVOICE.paid")}</p>
                      </div>
                      <div className="flex flex-row relative">
                        <p className="text-[1vw]">{t("INVOICE.credit")}</p>
                      </div>
                      <div className="flex flex-row relative">
                        <p className="text-[1vw]">{t("INVOICE.limit")}</p>
                      </div>
                    </div>
                    <div className="flex flex-col relative w-5/12 mt-4 pb-4 font-semibold">
                      <div className="flex flex-row relative">
                        <p className="text-[1vw]">
                          {" : "} {paidAmount}
                        </p>
                      </div>
                      <div className="flex flex-row relative">
                        <p className="text-[1vw]">
                          {" : "}{" "}
                          {item.paidAmount ? t("OTHER.yes") : t("OTHER.no")}
                        </p>
                      </div>
                      <div className="flex flex-row relative">
                        <p className="text-[1vw]">
                          {" : "} {dueDate}
                        </p>
                      </div>
                    </div>
                    <div className="flex flex-col relative w-2/12 mt-4 pb-4 items-end">
                      <h4 className="text-slate-400 text-[1vw]">
                        {t("INVOICE.sisa")}
                      </h4>
                      <p className="font-bold text-[1.5vw]">{restInvoice}</p>
                      <button
                        onClick={() => onSelectItem(item)}
                        style={{ backgroundColor: accentColor }}
                        className={`h-[5vh] w-[10vw] rounded-xl hover:opacity-80 ${
                          isDarkColor(accentColor) ? "text-white" : "text-black"
                        }`}
                      >
                        Detail
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
            <InvoiceWebPagination
              page={page}
              size={size}
              total={total}
              t={t}
              onChangePage={onChangePage}
              onChangeSize={onChangeSize}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
